import type { WorkflowStep } from '../services/api';

/**
 * Workflows kommen je nach Endpunkt mit steps als JSON-Zeichenkette (Liste)
 * oder bereits geparst (Einzelabruf). Beides wird hier zu einem Array.
 */
export const schritteAus = (workflow: { steps?: unknown } | null | undefined): WorkflowStep[] => {
  const roh = workflow?.steps;
  if (!roh) return [];
  if (Array.isArray(roh)) return roh as WorkflowStep[];
  if (typeof roh === 'string') {
    try {
      const wert = JSON.parse(roh);
      return Array.isArray(wert) ? (wert as WorkflowStep[]) : [];
    } catch {
      return [];
    }
  }
  return [];
};

/** {{variable}}-Platzhalter aus Prompts, ohne die step_-Ergebnisse. */
export const variablenAus = (prompts: string[]): string[] => {
  const namen = new Set<string>();
  prompts.forEach((p) => {
    (p.match(/\{\{(\w+)\}\}/g) || []).forEach((m) => namen.add(m.replace(/\{\{|\}\}/g, '')));
  });
  return [...namen].filter((n) => !n.startsWith('step_'));
};

/** Aus snake_case einen lesbaren Feldnamen machen: target_audience -> Target audience. */
export const variablenLabel = (name: string) => {
  const s = name.replace(/_/g, ' ').trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
};
